import api from "../../services/instanceapi";
import {getLogsByEntityAndAttribute} from "../../services/api";


export const GET_LOG = "GET_LOG"
export const GET_LOG_FAIL = "GET_LOG_FAIL"
export const getLogByEntityAndAttribute = (entity, attribute) => async (dispatch) => {
    try {
        const res = await api.get(getLogsByEntityAndAttribute(entity, attribute))
        dispatch({
            type: GET_LOG,
            payload: {
                data: res.data
            }
        })
    } catch (e) {
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: GET_LOG_FAIL,
                status : status
            })
        }
    }
}